import React, { FC } from 'react';
import ColorWrapper from '@styles/colors';
import { StyleSheet, View } from 'react-native';
import { scale } from '@components/frame';
import { useHandleNavigationMachinesHeader } from '@v2/pages/machines/hooks/useHandleNavigationMachineHeader';
import { useSelector } from 'react-redux';
import { isPhone } from '@helpers';
import { FeatureFlagsAvailable } from '@components/featureFlags';
import { HEADER_MOBILE_GAP_BETWEEN_LEVELS } from '@v2/pages/common/constants/base.constants';
import { selectFeatureFlags } from '@reducers/user';
import { NCFileBatchEventTypeMenu, PerformanceMenu, TimePeriodMenu, MainMenu } from '@v2/pages/machines/common/components/Header/components';
import { MachinesHeaderProps } from './types';

const MachinesHeader: FC<MachinesHeaderProps> = ({ C }) => {
  const { isPerformanceSubScreen, shouldDisplayTimePeriodMenu, isTimeline, shouldDisplayNcFileBatchEventsMenu, handleNavigate, activeScreenNameWithoutMachineMainScreen } =
    useHandleNavigationMachinesHeader();

  const rowStyles = { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' } as const;

  const styles = [
    rowStyles,
    { borderTopColor: C('Hairline/Light/No trans'), borderTopWidth: isPhone ? StyleSheet.hairlineWidth : 0, paddingTop: scale(12) },
  ];

  const featureFlags = useSelector(selectFeatureFlags);

  const shouldHideYear = isTimeline && !FeatureFlagsAvailable('timeline-year', featureFlags);

  const checkIsSelected = (title: string) => title === activeScreenNameWithoutMachineMainScreen;

  return (
    <View style={{ gap: scale(HEADER_MOBILE_GAP_BETWEEN_LEVELS) }}>
      <MainMenu />
      {shouldDisplayNcFileBatchEventsMenu && <NCFileBatchEventTypeMenu rowStyles={styles} />}
      {shouldDisplayTimePeriodMenu && <TimePeriodMenu rowStyles={styles} shouldHideYear={shouldHideYear} />}
      {isPerformanceSubScreen && <PerformanceMenu rowStyles={styles} checkIsSelected={checkIsSelected} onPress={handleNavigate} />}
    </View>
  );
};

export default ColorWrapper(MachinesHeader);
